module.exports = __webpack_public_path__ + "static/media/r_2_8.c3e7b796.png";